import React, { useEffect, useState } from 'react'
import Imprint from '../../pages/imprint.md'
import ReactMarkdown from 'react-markdown'
import LayoutWithoutMenu from '../../containers/LayoutWithoutMenu'

const ImprintScreen = () => {

  const [pageMarkdown, setPageMarkdown] = useState('')

  useEffect(() => {
    fetch(Imprint)
      .then(response => response.text())
      .then(text => {
        setPageMarkdown(text)
      })
  }, [])

  return (
    <LayoutWithoutMenu>
      <ReactMarkdown>
        {pageMarkdown}
      </ReactMarkdown>
    </LayoutWithoutMenu>
  )
}

export default ImprintScreen